import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from "./components/NavBar/navbar";
import Intro from "./components/Intro/intro";
import Skills from "./components/Skills/skills";
import Works from "./components/Works/works";
import Contact from "./components/Contact/contact"
import Footer from "./components/Footer/footer"
import Analytics from "./components/Analytics/analytics";
import WeddingRedirect from "./components/WeddingRedirect/WeddingRedirect";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/wedding" element={<WeddingRedirect />} />
          <Route path="/" element={
            <>
              <Navbar />
              <Intro />
              <Skills />
              <Works />
              <Contact />
              <Footer />
              <Analytics />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
